import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enHome from "./locales/en/home.json";
import enAbout from "./locales/en/about.json";
import enLogin from "./locales/en/login.json";
import enPath from "./locales/en/path.json";
import enPayment from "./locales/en/payment.json";
import enInstruction from "./locales/en/instruction.json";
import enFooter from "./locales/en/footer.json";
import enGrid from "./locales/en/grid.json";
import enResult from "./locales/en/result.json";
import enProfile from "./locales/en/profile.json";

import hiHome from "./locales/hi/home.json";
import hiAbout from "./locales/hi/about.json";
import hiLogin from "./locales/hi/login.json";
import hiPath from "./locales/hi/path.json";
import hiPayment from "./locales/hi/payment.json";
import hiInstruction from "./locales/hi/instruction.json";
import hiFooter from "./locales/hi/footer.json";
import hiGrid from "./locales/hi/grid.json";
import hiResult from "./locales/hi/result.json";
import hiProfile from "./locales/hi/profile.json";

import arHome from "./locales/ar/home.json";
import arAbout from "./locales/ar/about.json";
import arLogin from "./locales/ar/login.json";
import arPath from "./locales/ar/path.json";
import arPayment from "./locales/ar/payment.json";
import arInstruction from "./locales/ar/instruction.json";
import arFooter from "./locales/ar/footer.json";
import arGrid from "./locales/ar/grid.json";
import arResult from "./locales/ar/result.json";
import arProfile from "./locales/ar/profile.json";

import mlHome from "./locales/ml/home.json";
import mlAbout from "./locales/ml/about.json";
import mlLogin from "./locales/ml/login.json";
import mlPath from "./locales/ml/path.json";
import mlPayment from "./locales/ml/payment.json";
import mlInstruction from "./locales/ml/instruction.json";
import mlFooter from "./locales/ml/footer.json";
import mlGrid from "./locales/ml/grid.json";
import mlResult from "./locales/ml/result.json";
import mlProfile from "./locales/ml/profile.json";

import taHome from "./locales/ta/home.json";
import taAbout from "./locales/ta/about.json";
import taLogin from "./locales/ta/login.json";
import taPath from "./locales/ta/path.json";
import taPayment from "./locales/ta/payment.json";
import taInstruction from "./locales/ta/instruction.json";
import taFooter from "./locales/ta/footer.json";
import taGrid from "./locales/ta/grid.json";
import taResult from "./locales/ta/result.json";
import taProfile from "./locales/ta/profile.json";


i18n.use(initReactI18next).init({
  resources: {
    en: {
      home: enHome,
      about: enAbout,
      login: enLogin,
      path: enPath,
      payment: enPayment,
      instruction: enInstruction,
      footer: enFooter,
      grid: enGrid,
      result: enResult,
      profile: enProfile,
    },
    hi: {
      home: hiHome,
      about: hiAbout,
      login: hiLogin,
      path: hiPath,
      payment: hiPayment,
      instruction: hiInstruction,
      footer: hiFooter,
      grid: hiGrid,
      result: hiResult,
      profile: hiProfile,
    },
    ar: {
      home: arHome,
      about: arAbout,
      login: arLogin,
      path: arPath,
      payment: arPayment,
      instruction: arInstruction,
      footer: arFooter,
      grid: arGrid,
      result: arResult,
      profile: arProfile,
    },
    mal: {
      home: mlHome,
      about: mlAbout,
      login: mlLogin,
      path: mlPath,
      payment: mlPayment,
      instruction: mlInstruction,
      footer: mlFooter,
      grid: mlGrid,
      result: mlResult,
      profile: mlProfile,
    },
    ta: {
      home: taHome,
      about: taAbout,
      login: taLogin,
      path: taPath,
      payment: taPayment,
      instruction: taInstruction,
      footer: taFooter,
      grid: taGrid,
      result: taResult,
      profile: taProfile,
    }
  },
  lng: localStorage.getItem("lang") || "en",
  fallbackLng: "en",
  defaultNS: "home",
  ns: ["home", "about", "login", "path", "payment", "instruction", "footer", "grid", "result", "profile"],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

// Set initial direction and update on language change
const setDocumentDirection = (lng) => {
  const dir = lng === "ar" ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lng);
    if (document.body) {
      // Optional class hook for any RTL-specific CSS overrides
      document.body.classList.toggle("rtl", dir === "rtl");
    }
  }
};

setDocumentDirection(i18n.language);

i18n.on("languageChanged", (lng) => {
  setDocumentDirection(lng);
});

export default i18n;
